import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { loadPreviewDocumentFailed, loadPreviewDocumentSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* loadPreviewDocument(action) {
  try {
    const url = `${BACKEND_URL}/resources/applications/${action.payload.application_id}/action-document-preview`;
    const dataResponse = yield makeRequest(url, action.payload, action, 'POST', true);
    if (dataResponse.status === OK) {
      const data = yield dataResponse.blob();
      yield put(loadPreviewDocumentSuccessful());
      yield call(resolveActionPromise(action, data));
    } else {
      const data = yield dataResponse.json();
      yield put(loadPreviewDocumentFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(loadPreviewDocumentFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
